import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/monitoring" });

export const ActivityService = {
  getActivityLogs: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/activity-logs?${params.toString()}`);
  },
};
